/* Konfigurator Holz-Erinnerungskiste
 * Design (4 Layouts), Figur (Spardosen-Motive), Name und Geburtsdaten live auf dem Deckel.
 * Vorschaubild: assets/holzbox-mockup.jpg, Positionen in snippets/holzbox-vorschau-stage.liquid.
 */
(function () {
  'use strict';

  var GHOST_NAME = 'Sophia';
  var GHOST_DATEN = '21.06.2026 - 13:41 Uhr - 53cm - 3200g';
  var FIG_SCALE = { baby: 0.88, junge: 1, maedchen: 1 };
  var FARBEN = { rose: '#824b4b', olive: '#5b5641', braun: '#996037' };

  function boot() {
    var fields = document.querySelector('[data-holzbox-vorschau]');
    var wrap = document.querySelector('[data-holzbox-stage-wrap]');
    if (!fields || !wrap || wrap.dataset.holzboxInit) return;
    wrap.dataset.holzboxInit = '1';

    var stage = wrap.querySelector('[data-holzbox-stage]');
    var img = wrap.querySelector('[data-holzbox-img]');
    var deckel = wrap.querySelector('[data-holzbox-deckel]');
    var figur = wrap.querySelector('[data-holzbox-figur]');
    var nameEl = wrap.querySelector('[data-holzbox-text-name]');
    var datenEl = wrap.querySelector('[data-holzbox-text-daten]');
    var regenbogen = wrap.querySelector('[data-holzbox-regenbogen]');
    var herzlinie = wrap.querySelector('[data-holzbox-herzlinie]');

    var nameInput = fields.querySelector('[data-holzbox-name]');
    var errorEl = fields.querySelector('[data-holzbox-error]');
    var datumInput = fields.querySelector('[data-holzbox-datum]');
    var uhrInput = fields.querySelector('[data-holzbox-uhr]');
    var groesseInput = fields.querySelector('[data-holzbox-groesse]');
    var gewichtInput = fields.querySelector('[data-holzbox-gewicht]');
    var datenHidden = fields.querySelector('[data-holzbox-geburtsdaten]');
    var designRadios = Array.prototype.slice.call(fields.querySelectorAll('[data-holzbox-design]'));
    var farbRadios = Array.prototype.slice.call(fields.querySelectorAll('[data-holzbox-farbe]'));
    var farbeGewaehlt = false;
    var KALT = { tanne: 1, nachtblau: 1, anthrazit: 1 };
    var motivRadios = Array.prototype.slice.call(fields.querySelectorAll('[data-holzbox-motiv]'));
    var motivLabel = fields.querySelector('[data-holzbox-motiv-label]');
    var tabs = Array.prototype.slice.call(fields.querySelectorAll('[data-holzbox-tab]'));
    var panels = Array.prototype.slice.call(fields.querySelectorAll('[data-holzbox-panel]'));
    var showLink = fields.querySelector('[data-holzbox-show]');

    function checked(list) {
      for (var i = 0; i < list.length; i++) if (list[i].checked) return list[i];
      return list[0];
    }

    function layoutStage() {
      var w = stage.clientWidth;
      var h = stage.clientHeight;
      if (!w || !h) return 0;
      var ratio = (img.naturalWidth && img.naturalHeight) ? img.naturalHeight / img.naturalWidth : 1024 / 1536;
      var sb = stage.getBoundingClientRect();
      var ib = img.getBoundingClientRect();
      var bw = ib.width || w;
      var bh = ib.height || h;
      var s = Math.min(bw, bh / ratio);
      wrap.style.setProperty('--is', s + 'px');
      wrap.style.setProperty('--ix', ((bw - s) / 2 + (ib.left - sb.left)) + 'px');
      wrap.style.setProperty('--iy', (ib.top - sb.top) + 'px');
      return s;
    }

    function fit(el, size, maxW, min) {
      /* proportional statt in 1-px-Schritten: lange Namen liefen sonst nach 40 Schritten ueber (Druck passt stufenlos ein) */
      el.style.fontSize = size + 'px';
      var w = el.scrollWidth;
      if (w > maxW + 1) { size = Math.max(min, size * (maxW + 1) / w); el.style.fontSize = size + 'px'; }
      var guard = 8;
      while (guard-- > 0 && size > min && el.scrollWidth > maxW + 1) {
        size = Math.max(min, size - 0.5);
        el.style.fontSize = size + 'px';
      }
    }

    /* Geburtsdaten: "21.06.2026 - 13:41 Uhr - 53cm - 3200g", nur gefuellte Teile */
    function daten() {
      var teile = [];
      var d = datumInput.value.trim(), u = uhrInput.value.trim(), g = groesseInput.value.trim(), k = gewichtInput.value.trim();
      if (d) teile.push(d);
      if (u) teile.push(u + ' Uhr');
      if (g) teile.push(g + 'cm');
      if (k) teile.push(k + 'g');
      return teile.join(' - ');
    }

    function syncProps() {
      var s = daten();
      if (s) {
        datenHidden.value = s;
        datenHidden.setAttribute('name', 'properties[Geburtsdaten]');
      } else {
        datenHidden.value = '';
        datenHidden.removeAttribute('name');
      }
    }

    function render() {
      var s = layoutStage() || stage.clientWidth;
      if (!s) return;
      var dw = s * 0.585; /* Deckelrahmen 3:2, hoehenfuellend im Foto */

      var design = checked(designRadios);
      var key = design ? design.dataset.holzboxDesign : 'regenbogen';
      wrap.dataset.design = key;

      var r = checked(motivRadios);
      var kat = 'maedchen';
      if (r) {
        var src = r.dataset.src;
        if (src && figur.getAttribute('src') !== src) figur.setAttribute('src', src);
        kat = r.dataset.kategorie || 'maedchen';
        if (motivLabel) motivLabel.textContent = r.value;
      }
      wrap.style.setProperty('--fig-scale', String(FIG_SCALE[kat] || 1));

      /* Schriftfarbe: Vorschlag nach Kategorie und Design, solange der Kunde nichts gewaehlt hat */
      if (!farbeGewaehlt) {
        var vorschlag = key === 'konfetti' ? 'dunkelbraun' : (kat === 'junge' ? 'tanne' : 'weinrot');
        farbRadios.forEach(function (fr) { fr.checked = fr.dataset.holzboxFarbe === vorschlag; });
      }
      var fr = checked(farbRadios);
      var farbKey = fr ? fr.dataset.holzboxFarbe : 'weinrot';
      var farbe = fr ? fr.dataset.hex : '#7a2b3a';
      var kalt = !!KALT[farbKey];
      if (regenbogen) regenbogen.setAttribute('src', regenbogen.dataset[kalt ? 'srcOlive' : 'srcRose']);
      if (herzlinie) herzlinie.style.backgroundColor = farbe;

      /* Name */
      var name = nameInput.value.trim() || GHOST_NAME;
      nameEl.textContent = name;
      nameEl.style.color = farbe;
      nameEl.style.opacity = nameInput.value.trim() ? '1' : '0.45';
      var faktor = { regenbogen: 0.088, herz: 0.118, konfetti: 0.115, wildblumen: 0.094, wiese: 0.094, mittig: 0.108, safari: 0.094, waldtiere: 0.094, unterwasser: 0.094, boho: 0.094, nachthimmel: 0.094, ballons: 0.094 }[key] || 0.11;
      var breite = { regenbogen: 0.46, herz: 0.46, konfetti: 0.44, wildblumen: 0.44, wiese: 0.44, mittig: 0.48, safari: 0.44, waldtiere: 0.44, unterwasser: 0.44, boho: 0.44, nachthimmel: 0.44, ballons: 0.44 }[key] || 0.44;
      fit(nameEl, dw * faktor, nameEl.clientWidth + 1, dw * 0.03); /* maxW = Boxbreite, sonst schrumpft es bis zum Minimum */

      /* Geburtsdaten */
      var dz = daten();
      datenEl.textContent = dz || GHOST_DATEN;
      datenEl.style.color = farbe;
      datenEl.style.opacity = dz ? '1' : '0.4';
      var dfaktor = { regenbogen: 0.03, herz: 0.026, konfetti: 0.023, wildblumen: 0.02, wiese: 0.02, mittig: 0.024, safari: 0.02, waldtiere: 0.02, unterwasser: 0.02, boho: 0.02, nachthimmel: 0.02, ballons: 0.02 }[key] || 0.025;
      fit(datenEl, dw * dfaktor, datenEl.clientWidth + 1, dw * 0.012);
    }

    function showPanel(kat) {
      tabs.forEach(function (t) {
        var on = t.dataset.holzboxTab === kat;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) { p.hidden = p.dataset.holzboxPanel !== kat; });
    }

    function open() {
      wrap.classList.add('is-open');
      render();
    }

    wrap.querySelector('[data-holzbox-close]').addEventListener('click', function () {
      wrap.classList.remove('is-open');
    });

    function zeigeFehler(input, el) {
      if (el) el.hidden = false;
      input.classList.add('is-invalid');
      fields.scrollIntoView({ block: 'center', behavior: 'smooth' });
      window.setTimeout(function () { input.focus({ preventScroll: true }); }, 350);
    }

    document.addEventListener('click', function (e) {
      var kaufBtn = e.target.closest('[data-add-to-cart], button[name="add"]');
      if (!kaufBtn) return;
      var btnFormEl = kaufBtn.closest('form');
      var btnForm = kaufBtn.getAttribute('form') || (btnFormEl && btnFormEl.getAttribute('id'));
      if (btnForm && btnForm !== fields.dataset.formId) return;
      syncProps();
      if (!nameInput.value.trim()) {
        e.preventDefault();
        e.stopPropagation();
        zeigeFehler(nameInput, errorEl);
      }
    }, true);

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        showPanel(t.dataset.holzboxTab);
        var cur = checked(motivRadios);
        if (!cur || cur.dataset.kategorie !== t.dataset.holzboxTab) {
          var first = fields.querySelector('[data-holzbox-motiv][data-kategorie="' + t.dataset.holzboxTab + '"]');
          if (first) first.checked = true;
        }
        open();
      });
    });
    designRadios.forEach(function (r) { r.addEventListener('change', open); });
    farbRadios.forEach(function (r) { r.addEventListener('change', function () { farbeGewaehlt = true; open(); }); });
    motivRadios.forEach(function (r) { r.addEventListener('change', open); });

    nameInput.addEventListener('focus', open);
    nameInput.addEventListener('input', function () {
      if (nameInput.value.trim()) {
        if (errorEl) errorEl.hidden = true;
        nameInput.classList.remove('is-invalid');
      }
      render();
    });

    /* Zifferntastatur ohne Punkt/Doppelpunkt: automatisch setzen */
    datumInput.addEventListener('input', function () {
      var z = datumInput.value.replace(/\D/g, '').slice(0, 8);
      var out = z;
      if (z.length > 4) out = z.slice(0, 2) + '.' + z.slice(2, 4) + '.' + z.slice(4);
      else if (z.length > 2) out = z.slice(0, 2) + '.' + z.slice(2);
      if (out !== datumInput.value) datumInput.value = out;
    });
    uhrInput.addEventListener('input', function () {
      var z = uhrInput.value.replace(/\D/g, '').slice(0, 4);
      var out = z.length > 2 ? z.slice(0, 2) + ':' + z.slice(2) : z;
      if (out !== uhrInput.value) uhrInput.value = out;
    });
    [datumInput, uhrInput, groesseInput, gewichtInput].forEach(function (inp) {
      inp.addEventListener('focus', open);
      inp.addEventListener('input', function () { syncProps(); render(); });
    });

    if (showLink) {
      showLink.addEventListener('click', function () {
        open();
        wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    }
    img.addEventListener('load', render);
    figur.addEventListener('load', render);
    window.addEventListener('resize', render);

    syncProps();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(render);
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
